import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'constants/routes';
import { X_PATH } from 'constants/xPath';
import useAuthentication from 'hooks/useAuthentication';
import AccountMenu from '#web-components/components/AccountMenu';
import MenuItem from '#web-components/components/MenuList/components/MenuItem';

export default function Menu() {
  const authentication = useAuthentication();
  const history = useHistory();
  const userInfo = authentication.info;
  const { t } = useTranslation('components');

  const handleLogout = useCallback((): void => {
    authentication.logout();
  }, [authentication]);

  const handleNavigateTo = useCallback((path: string) => () => {
    history.push(path);
  }, [history]);

  if (!(authentication.authenticated)) {
    return null;
  }

  const accountName = `${userInfo?.given_name} ${userInfo?.family_name && userInfo?.family_name.charAt(0)}.`;

  return (
    <AccountMenu
      name={accountName}
    >
      <div>
        {userInfo?.name && (
          <MenuItem data-xpath="userInfo.name">
            {userInfo.name}
          </MenuItem>
        )}
        <MenuItem data-xpath="header.profile" onClick={handleNavigateTo(ROUTES.PROFILE)}>
          {t('header.profile')}
        </MenuItem>
        <MenuItem
          data-xpath={X_PATH.logout}
          onClick={handleLogout}
        >
          {t('header.logout')}
        </MenuItem>
      </div>
    </AccountMenu>
  );
}
